module.exports = __webpack_public_path__ + "img/cat-tattoo-designs-11041613.jpg";